var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _polygon, _path1, _polygon2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _path19, _rect, _rect2, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _polygon3, _rect4, _rect5, _rect6, _circle0, _circle1, _circle10, _rect7, _rect8, _rect9, _circle11, _circle12, _circle13, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle14, _path28, _path29, _circle15, _path30, _path31, _circle16, _path32, _path33, _path34, _polygon4, _path35, _polygon5, _path36, _polygon6, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 864,
    height: 645,
    viewBox: "0 0 864 645",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M459.6747,727.48145l-13.16937,12.124,10.466-17.56112C448.72566,707.0914,435.24,694.16844,435.24,694.16844s-27.97814,26.80527-27.97814,47.876S419.788,770.47218,435.24,770.47218c15.45172,0,27.97789-7.35709,27.97789-28.42778A36.96212,36.96212,0,0,0,459.6747,727.48145Z",
    transform: "translate(-168 -127.5)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M443.11853,740.26178v1.03858c-.06169,12.07255-2.09775,21.492-6.0928,28.12466-.05655.0977-.11825.19024-.17483.28793l-.44732-.27249-.42673-.26737c4.43207-7.16227,6.00026-17.28612,6.05681-27.81614.00515-.33937.01029-.68385.00515-1.02833-.01544-4.4578-.28793-8.967-.725-13.34765-.03085-.33936-.06684-.68384-.10284-1.02832-.6067-5.77918-1.48079-11.30127-2.37542-16.09841-.0617-.33936-.12854-.6787-.19539-1.01291-1.54763-8.11346-3.12611-13.99033-3.486-15.29117-.04111-.15939-.06684-.24679-.072-.26735l.48846-.13883.00515-.00515.4936-.13883c.00515.02059.09255.31366.2365.85867.55016,2.03606,1.97954,7.5633,3.38319,14.85411.0617.32908.12854.66844.19024,1.00777.7301,3.89221,1.44479,8.242,2.01039,12.80776q.21593,1.7199.38562,3.39349c.04111.34448.07711.689.108,1.02832Q443.09286,734.05328,443.11853,740.26178Z",
    transform: "translate(-168 -127.5)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M439.68908,708.71278c-.34448.04629-.6941.09258-1.04888.12855a28.365,28.365,0,0,1-2.89988.14912,27.59179,27.59179,0,0,1-11.92856-2.6942c-.21594.27249-.43188.545-.653.82265a28.61356,28.61356,0,0,0,12.58152,2.89988,29.34686,29.34686,0,0,0,3.09527-.16454c.34962-.036.69925-.08228,1.04373-.13369a28.37271,28.37271,0,0,0,8.20089-2.48341q-.33164-.42417-.64785-.83294A27.49673,27.49673,0,0,1,439.68908,708.71278Z",
    transform: "translate(-168 -127.5)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M442.27533,725.9218q-.53215.03083-1.06432.03085c-.108.00514-.22108.00514-.32907.00514a27.73816,27.73816,0,0,1-22.7671-11.89256c-.20565.30333-.41132.6067-.61182.91519a28.76813,28.76813,0,0,0,23.37892,12.0057c.144,0,.28793,0,.43191-.00515.35989-.00515.71466-.01544,1.06944-.03085a28.616,28.616,0,0,0,15.24491-5.34729c-.16454-.30334-.32907-.60671-.49876-.91005A27.54766,27.54766,0,0,1,442.27533,725.9218Z",
    transform: "translate(-168 -127.5)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M443.11853,740.26178c-.35989.03085-.7198.0514-1.07972.06684-.38563.01541-.77125.0257-1.15687.0257a27.81317,27.81317,0,0,1-26.66442-20.0112c-.23138.4165-.46276.82783-.68385,1.2443a28.83172,28.83172,0,0,0,27.34827,19.79523c.38562,0,.77124-.00515,1.15172-.0257.36507-.0103.725-.03085,1.08487-.05659a28.74732,28.74732,0,0,0,18.97259-9.26006c-.108-.38047-.23138-.7558-.35478-1.13627A27.72345,27.72345,0,0,1,443.11853,740.26178Z",
    transform: "translate(-168 -127.5)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M953.71779,745.93266l-17.87068,1.03053,19.22589-6.9495c3.09969-16.792.85972-35.33521.85972-35.33521s-38.63028,3-51.98541,19.29768-8.32955,29.92761,3.62218,39.72146c11.95154,9.79368,26.30334,12.04255,39.65848-4.25513A36.96207,36.96207,0,0,0,953.71779,745.93266Z",
    transform: "translate(-168 -127.5)",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M932.81149,745.32423l-.65828.80332c-7.6996,9.29872-15.24473,15.29393-22.53876,17.892-.10566.03972-.212.0722-.31772.1119l-.17328-.49429-.1606-.47728c7.96773-2.73069,15.59744-9.56729,22.31537-17.67617.21908-.25923.4414-.52241.65576-.79212,2.81353-3.45779,5.46079-7.11825,7.89934-10.78359.19124-.282.38174-.5713.57224-.86057,3.19371-4.8546,6.01767-9.67982,8.36624-13.95734.16737-.30159.33075-.60642.49088-.9073,3.94546-7.2565,6.44945-12.80259,6.99557-14.03689.06922-.14934.10472-.23325.11376-.25242l.46581.20222.00724-.00072.46979.20548c-.00906.01918-.12722.30126-.36132.81405-.865,1.92355-3.26268,7.10472-6.79809,13.63366-.16085.29364-.32425.59849-.49161.90006-1.90226,3.47329-4.10649,7.29077-6.56289,11.18074q-.9231,1.46717-1.8526,2.8692c-.18655.2925-.377.58176-.56828.8638Q936.72674,740.50584,932.81149,745.32423Z",
    transform: "translate(-168 -127.5)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M950.15544,718.74815c-.29579-.18253-.59555-.36833-.89276-.56538a28.36577,28.36577,0,0,1-2.33751-1.72267,27.59179,27.59179,0,0,1-7.5188-9.64453c-.33974.0739-.67949.14782-1.02647.22244a28.61347,28.61347,0,0,0,7.8935,10.21747,29.34381,29.34381,0,0,0,2.4984,1.83459c.29324.19377.593.37956.892.55814a28.37233,28.37233,0,0,0,7.91724,3.27707q.01235-.53828.02685-1.05488A27.497,27.497,0,0,1,950.15544,718.74815Z",
    transform: "translate(-168 -127.5)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M941.24834,733.69815q-.43116-.31346-.84278-.65074c-.08679-.06446-.17427-.13614-.25779-.20459a27.73816,27.73816,0,0,1-10.072-23.629c-.35133.10428-.70269.20857-1.0533.32009A28.76814,28.76814,0,0,0,939.496,733.63821c.11137.09125.22271.18249.33733.26977.28163.22413.56256.441.84674.654a28.616,28.616,0,0,0,15.18083,5.52661c.065-.33892.13-.67785.191-1.02A27.54779,27.54779,0,0,1,941.24834,733.69815Z",
    transform: "translate(-168 -127.5)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M932.81149,745.32423c-.29792-.20425-.58933-.41648-.87751-.63266-.308-.2325-.61283-.46895-.9111-.71337a27.8132,27.8132,0,0,1-7.9407-32.37878c-.44295.1755-.88262.347-1.3176.529a28.83171,28.83171,0,0,0,8.60653,32.64516c.29826.24442.5998.48486.90711.71011.2889.22343.58031.43565.875.64386a28.74739,28.74739,0,0,0,20.5441,4.86286c.15763-.36273.30008-.73125.4458-1.10375A27.72351,27.72351,0,0,1,932.81149,745.32423Z",
    transform: "translate(-168 -127.5)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "165.74 630.543 179.675 630.542 182.261 576.504 165.737 576.794 165.74 630.543",
    fill: "#ffb6b6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M330.18516,753.49344l27.44293-.00111h.00111a17.4897,17.4897,0,0,1,17.48878,17.4885v.56832l-44.932.00166Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "109.407 630.543 123.342 630.542 126.104 576.504 109.404 576.794 109.407 630.543",
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M273.85218,753.49344l27.44294-.00111h.00111a17.48972,17.48972,0,0,1,17.48878,17.4885v.56832l-44.932.00166Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M413.14987,526.5379a11.04758,11.04758,0,0,0-13.35281-10.42456L379.451,482.5375l-8.74513,18.43186,20.66174,29.05839a11.10746,11.10746,0,0,0,21.78231-3.48985Z",
    transform: "translate(-168 -127.5)",
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M243.13163,561.65794a11.0476,11.0476,0,0,0-4.11311-16.43323l4.61713-38.987-18.234,9.15041-1.589,35.61983a11.10746,11.10746,0,0,0,19.31907,10.65Z",
    transform: "translate(-168 -127.5)",
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.91062,522.16437l9.8681,5.84557s8.01821,5.10395,5.32182,40.6056-5.91853,177.7366-5.91853,177.7366H333.69033l-28.329-169.90775-10.33677,171.749-18.41229-.92062s-37.61834-195.53635-21.34086-216.7576Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.31573,396.52776s47.98833-15.42735,86.70653-1.04379l-3.16976,74.68381,23.88287,58.25642s-75.92658,29.452-101.229,4.70056l7.37942-58.35391Z",
    transform: "translate(-168 -127.5)",
    fill: "#09c4a9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M323.12139,404.25512l10.05624-8.77115s6.708-.07937,12.48069,10.24079,16.2311,43.63227,16.2311,43.63227l33.48208,56.71471L380.64167,516.1985l-53.10275-74.266Z",
    transform: "translate(-168 -127.5)",
    fill: "#09c4a9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M251.096,400.21022l.68585-4.67919s-18.698,1.38335-20.27971,19.39987-7.36492,119.67989-7.36492,119.67989l18.49508,3.68246L261.031,433.95072Z",
    transform: "translate(-168 -127.5)",
    fill: "#09c4a9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M315.9176,369.53567l-56.09711,11.04639a4.441,4.441,0,0,1-5.20941-3.49532L249.84971,352.907a33.02313,33.02313,0,0,1,64.80183-12.76049l4.76138,24.17979A4.441,4.441,0,0,1,315.9176,369.53567Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.7385,
    cy: 221.92969,
    r: 24.2114,
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M322.793,341.055l-34.302,6.7546-1.32159-4.85547-.78894,5.27106-5.28178,1.04007-2.61909-9.62344-1.56373,10.4471-10.22,2.01247-.09523-.4836a26.1521,26.1521,0,0,1,20.58328-30.67758l4.8362-.95233a26.15232,26.15232,0,0,1,30.67763,20.58352Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M294.24131,378.49273a4.53027,4.53027,0,0,1-.78365.08367l-25.99014.51432-8.17431-41.51179,27.6495-5.44461-.52738.93292c-7.33685,12.983,3.38513,29.58121,10.4293,38.31955a4.37026,4.37026,0,0,1,.55574,4.61969A4.4181,4.4181,0,0,1,294.24131,378.49273Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "b0371f3f-df42-4d60-b6c1-6000de199dd5",
    "data-name": "Rectangle 246",
    x: 160.34726,
    y: 0.27183,
    width: 334.98147,
    height: 175.88954,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "a5ec3362-5fc6-49dd-bbc1-e584c03fc30b",
    "data-name": "Rectangle 264",
    x: 160.14263,
    width: 334.98147,
    height: 20.39046,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "edb19af0-e7ad-43aa-9651-c68038fb40c2",
    "data-name": "Rectangle 247",
    x: 167.92263,
    y: 28.65783,
    width: 321.13629,
    height: 138.23189,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "fcfbd1c3-546b-4aa9-92d2-19035f23e7a3",
    "data-name": "Ellipse 194",
    cx: 191.88588,
    cy: 10.14313,
    r: 3.37299,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "fcf1e260-d16a-4b37-91b5-eb72ad8ee2c7",
    "data-name": "Ellipse 195",
    cx: 204.68919,
    cy: 10.14313,
    r: 3.37299,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "ae552ed4-f0ed-4b8a-a24a-450e5f71adc4",
    "data-name": "Ellipse 246",
    cx: 179.04934,
    cy: 10.14313,
    r: 3.37299,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.63328,
    cy: 127.20928,
    r: 5.92621,
    fill: "#e4e4e4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.98142,
    cy: 111.68894,
    r: 5.92621,
    fill: "#e4e4e4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.32956,
    cy: 127.20928,
    r: 5.92621,
    fill: "#e4e4e4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.67771,
    cy: 48.92263,
    r: 5.92621,
    fill: "#e4e4e4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.02585,
    cy: 48.19321,
    r: 5.92621,
    fill: "#e4e4e4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "327.454 128.537 274.981 112.234 223.226 128 222.041 126.419 274.981 109.766 327.205 125.882 379.1 48.091 379.309 48.006 431.657 47.914 432.395 49.747 380.255 49.755 327.454 128.537",
    fill: "#e4e4e4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "a979eff9-2035-45aa-8fad-490bbaa22894",
    "data-name": "Rectangle 246",
    x: 236.19416,
    y: 230.62976,
    width: 315.23768,
    height: 165.52262,
    fill: "#f2f2f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "b5344e31-85e8-4079-8f4b-e609523654c2",
    "data-name": "Rectangle 264",
    x: 236.0016,
    y: 230.37394,
    width: 315.23768,
    height: 19.18865,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "a6983896-3ceb-4bf9-866b-7e40cad74d1b",
    "data-name": "Rectangle 247",
    x: 242.84117,
    y: 256.23473,
    width: 302.69053,
    height: 131.48887,
    fill: "#fff"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "f96e66fe-9216-4da2-bba4-b63d176988a9",
    "data-name": "Ellipse 194",
    cx: 265.8739,
    cy: 239.91924,
    r: 3.17418,
    fill: "#fff"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "e3ffbb79-e13a-4bd7-b23c-45510780cb2f",
    "data-name": "Ellipse 195",
    cx: 277.92258,
    cy: 239.91924,
    r: 3.17418,
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "ec6ea03b-7290-43d8-8b25-59bf30f1f0ee",
    "data-name": "Ellipse 246",
    cx: 253.79395,
    cy: 239.91924,
    r: 3.17418,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "e9e5cf6b-8f55-43bf-8281-302b4fb1e9d5",
    "data-name": "Rectangle 246",
    x: 387.94795,
    y: 72.53937,
    width: 373.92653,
    height: 196.33852,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "e4e8a65e-8422-4898-a810-30d755c7dafc",
    "data-name": "Rectangle 264",
    x: 387.71953,
    y: 72.23593,
    width: 373.92653,
    height: 22.76106,
    fill: "#09c4a9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "b6acd298-89f8-46a0-ab3e-c2f0533bc288",
    "data-name": "Rectangle 247",
    x: 396.3424,
    y: 101.98817,
    width: 356.53714,
    height: 155.93232,
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "a2e6f9e4-3ad4-420f-8fe3-197d901d1e70",
    "data-name": "Ellipse 194",
    cx: 423.15326,
    cy: 83.55831,
    r: 3.76513,
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "b303a717-eadc-4672-a419-54a1feb6afd8",
    "data-name": "Ellipse 195",
    cx: 437.44508,
    cy: 83.55831,
    r: 3.76513,
    fill: "#fff"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "b1ff2c46-8045-41fc-afe2-76f8fb520d89",
    "data-name": "Ellipse 246",
    cx: 408.82434,
    cy: 83.55831,
    r: 3.76513,
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M745.15661,263.656a3.08356,3.08356,0,0,0,0,6.11358H871.40974a3.08356,3.08356,0,0,0,0-6.11358Z",
    transform: "translate(-168 -127.5)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M745.15661,335.75166a3.08356,3.08356,0,0,0,0,6.11358H871.40974a3.08356,3.08356,0,0,0,0-6.11358Z",
    transform: "translate(-168 -127.5)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M745.15661,281.99672a3.08356,3.08356,0,0,0,0,6.11358h54.3271a3.08356,3.08356,0,0,0,0-6.11358Z",
    transform: "translate(-168 -127.5)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M745.15661,299.479a3.08357,3.08357,0,0,0,0,6.11359H871.40974a3.08357,3.08357,0,0,0,0-6.11359Z",
    transform: "translate(-168 -127.5)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M745.15661,317.81974a3.08356,3.08356,0,0,0,0,6.11358h54.3271a3.08356,3.08356,0,0,0,0-6.11358Z",
    transform: "translate(-168 -127.5)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M671.576,338.5163a2.90959,2.90959,0,1,0,.00283-5.81917H612.5531a2.90959,2.90959,0,1,0-.00283,5.81917H671.576Z",
    transform: "translate(-168 -127.5)",
    fill: "#e4e4e4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M671.576,321.37368a2.90959,2.90959,0,0,0,0-5.81917H612.5531a2.90959,2.90959,0,1,0-.00283,5.81917H671.576Z",
    transform: "translate(-168 -127.5)",
    fill: "#e4e4e4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M642.06435,267.00489a18.31449,18.31449,0,1,1-18.31447,18.3145v0A18.33521,18.33521,0,0,1,642.06435,267.00489Z",
    transform: "translate(-168 -127.5)",
    fill: "#09c4a9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.95202,
    cy: 294.30697,
    r: 7.16563,
    fill: "#e4e4e4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M609.08471,416.23084a4.85961,4.85961,0,1,1,0,9.71921H533.72106a4.85961,4.85961,0,1,1,0-9.71921h75.36365m0-1.1902H533.72106a6.04981,6.04981,0,1,0,0,12.09962h75.36365a6.04981,6.04981,0,1,0,0-12.09962Z",
    transform: "translate(-168 -127.5)",
    fill: "#e4e4e4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M579.34757,427.14024h-56.733a6.0498,6.0498,0,1,1,0-12.0996h56.733a6.0498,6.0498,0,0,1,0,12.0996Z",
    transform: "translate(-168 -127.5)",
    fill: "#e4e4e4"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.95202,
    cy: 324.06213,
    r: 7.16563,
    fill: "#e4e4e4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M609.08471,445.986a4.85961,4.85961,0,1,1,0,9.71921H533.72106a4.85961,4.85961,0,1,1,0-9.71921h75.36365m0-1.19021H533.72106a6.04981,6.04981,0,1,0,0,12.09962h75.36365a6.04981,6.04981,0,1,0,0-12.09962Z",
    transform: "translate(-168 -127.5)",
    fill: "#e4e4e4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M600.77128,456.8954H522.61454a6.0498,6.0498,0,0,1,0-12.09961h78.15674a6.04981,6.04981,0,0,1,0,12.09961Z",
    transform: "translate(-168 -127.5)",
    fill: "#e4e4e4"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.95202,
    cy: 353.81729,
    r: 7.16563,
    fill: "#e4e4e4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M609.08471,475.74116a4.8596,4.8596,0,1,1,0,9.7192H533.72106a4.8596,4.8596,0,1,1,0-9.7192h75.36365m0-1.19021H533.72106a6.04981,6.04981,0,1,0,0,12.09962h75.36365a6.04981,6.04981,0,1,0,0-12.09962Z",
    transform: "translate(-168 -127.5)",
    fill: "#e4e4e4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M609.35324,486.65055h-86.7387a6.0498,6.0498,0,1,1,0-12.0996h86.7387a6.0498,6.0498,0,0,1,0,12.0996Z",
    transform: "translate(-168 -127.5)",
    fill: "#e4e4e4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M834.869,559.069a9.31107,9.31107,0,0,0-2.48578-14.05934l6.18842-32.50452-15.87138,6.61427-3.44338,29.8528A9.36152,9.36152,0,0,0,834.869,559.069Z",
    transform: "translate(-168 -127.5)",
    fill: "#ffb7b7"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "746.005 631.024 732.566 631.023 726.173 579.187 746.008 579.188 746.005 631.024",
    fill: "#ffb7b7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M917.43255,771.55081l-43.33277-.0016v-.54809a16.86724,16.86724,0,0,1,16.86633-16.866h.00107l26.46618.00107Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "672.561 631.024 659.122 631.023 652.729 579.187 672.564 579.188 672.561 631.024",
    fill: "#ffb7b7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M840.70006,771.55081l-43.33277-.0016v-.54809a16.86722,16.86722,0,0,1,16.86633-16.866h.00107l26.46618.00107Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "671.46 412.093 658.306 442.398 647.455 616.58 674.86 615.484 682.344 532.451 705.433 458.495 718.707 540.944 724.188 613.291 746.863 614.273 755.9 412.093 671.46 412.093",
    fill: "#2f2e41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M905.21362,390.05686l-38.12506.95367-22.38329,11.49068-1.22837,84.77572-13.96,58.5306s87.22383,6.003,99.2818-2.76638l-14.25032-66.86688,19.11285-72.264Z",
    transform: "translate(-168 -127.5)",
    fill: "#3f3d56"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M848.77763,403.82649l-4.07236-1.32528S831.78686,410.792,833.016,430.8364c0,0-.48417,10.37227-.02185,17.27532.53028,7.91777-15.3465,86.5981-15.3465,86.5981h23.01975l9.86561-71.2516Z",
    transform: "translate(-168 -127.5)",
    fill: "#3f3d56"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M933.0639,560.1652a9.31107,9.31107,0,0,1,2.48578-14.05934l-6.18842-32.50452,15.87138,6.61426,3.44338,29.85281A9.36152,9.36152,0,0,1,933.0639,560.1652Z",
    transform: "translate(-168 -127.5)",
    fill: "#ffb7b7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M927.92474,404.92267l4.07236-1.32528s12.9184,8.29076,11.68924,28.33519c0,0,.48418,10.37227.02185,17.27532-.53028,7.91777,6.57708,86.59809,6.57708,86.59809H927.26552l-9.86561-71.2516Z",
    transform: "translate(-168 -127.5)",
    fill: "#3f3d56"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M914.57247,354.48983A26.42886,26.42886,0,1,1,888.14359,328.061h0a26.36309,26.36309,0,0,1,26.42885,26.29718Q914.57262,354.424,914.57247,354.48983Z",
    transform: "translate(-168 -127.5)",
    fill: "#ffb7b7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M861.80256,318.99109c3.096-6.65745,9.08738-5.34121,14.32725-3.08453,6.63549-1.47185,12.94628-5.87836,20.09563-3.27237,7.04243,10.2428,30.687,7.22922,25.65667,23.90457-.00658,3.99577,7.5188,1.67,6.205,8.21413,3.98647,12.59416-14.38938,36.44561-24.93854,31.42289,2.60895-4.78153,8.56881-15.642-.47064-16.71917-19.44523,18.09309-2.00625-34.45333-26.43873-19.172C868.14949,347.688,857.07439,326.39637,861.80256,318.99109Z",
    transform: "translate(-168 -127.5)",
    fill: "#2f2e41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1031,772.5H169a1,1,0,0,1,0-2h862a1,1,0,0,1,0,2Z",
    transform: "translate(-168 -127.5)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.fc2477e033b4573bf44e030897329c29.svg";
export { ForwardRef as ReactComponent };